import React, { Fragment, useState } from 'react';
import { useTranslate } from 'react-admin';

import IdentityForm from './IdentityForm';
import { EditButton, Drawer } from '~/components';
import { EditForm } from '~/components/ra';
import { Identity } from '~/types/identities';
import { l } from './IdentityShow';

interface Props {
  identityRecord?: Identity;
  permissions?: string[];
}

const IdentityEdit = (props: Props) => {
  const { identityRecord, permissions } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  if (!identityRecord) return null;
  return (
    <Fragment>
      <EditButton onClick={handleOpen} disabled={!permissions?.includes('identity.update')} />
      <Drawer heading={t('editTeamMember')} open={open} onClose={handleClose}>
        <EditForm resource='team' record={identityRecord}>
          <IdentityForm edit record={identityRecord} />
        </EditForm>
      </Drawer>
    </Fragment>
  );
};

export default IdentityEdit;
